<template>
  <div id="app" @click="isTimeOut()">
    <!-- <el-button @click="goHomePage">go login</el-button> -->
    <router-view />
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
// import axios from 'axios'
import { ElButton } from "element-plus";
// import autofit from "autofit.js";
export default {
  name: "app",
  components: {
    ElButton,
    // HelloWorld
  },

  data() {
    return {
      lastTime: null,
      //60分钟未检测到鼠标点击就退出登录，后台正常校验20h
      // timeOut: 60 * 1000 * 60,
      timeOut: 60 * 1000 * 60,
    };
  },
  onMounted() {
    // autofit.init({
    //   dh: 1080,
    //   dw: 1920,
    //   el: "#app",
    //   resize: true,
    // }, false)
  },
  mounted() { },
  onBeforeUnmount() {
    // autofit.off();
  },

  methods: {
    // 全局监听得点击事件
    isTimeOut() {
      var currentTime = new Date().getTime();
      // 判断上次最后一次点击的时间和这次点击的时间间隔
      if (currentTime - this.lastTime > this.timeOut) {
        //这个是判断 当前用户是否登录，根据自己的情况写
        // if (null != sessionStorage.getItem('token')) {
        // console.log("router:", this.$router);
        if (
          this.$router.currentRoute._value.name == "login" ||
          this.$router.currentRoute._value.name == "register"
        ) {
          this.lastTime = new Date().getTime();
        } else {
          this.$alert("身份验证已过期，请重新登录", "提示", {
            confirmButtonText: "确定",
            callback: (action) => {
              //这里写路由（跳转到登录页）
              this.$router.replace("/login");
            },
          });
        }
      } else {
        // 如果在期限内点击，则把这次点击的时间覆盖掉之前存的最后一次点击的时间
        this.lastTime = new Date().getTime();
      }
    },
  },
  created() {
    // this.lastTime = new Date().getTime();
    // //如果地址中输入的注册页，可以直接进入注册页，输入其它的还是进入登录页
    // // console.log("window.location.pathname:", window.location.pathname);
    // // window.location.href = "http://99316aplp681.vicp.fun/home?signature=eyJhbGciOiJIUzUxMiJ9.eyJsb2dpbl91c2VyX2tleSI6ImZjOTYxMzk1LTZlZTctNDhmZS04YzZjLWJjZGEyN2MxODAwOSJ9.ZmImPsGwwhWfj59BHtQcWRy0nHGdkCnF5DyD1X9hFX81C_PR2EiLfufvrcwAvauZyHXV7qkdJfn6PbJMtijDyw&mark=1";
    // const queryParams = new URLSearchParams(window.location.search);
    // let signature = queryParams.get('signature');
    // if (signature) {
    //   window.sessionStorage.signature = signature;
    // }
    // let mark = queryParams.get('mark');
    // if (mark) {
    //   window.sessionStorage.mark = mark;
    // }
    // if (window.location.pathname == "/home" && signature) {
    //   this.$router.replace("/home")
    // } else if (window.location.pathname == "/register") {
    //   this.$router.replace("/register");
    // } else {
    //   // this.$router.replace("/register");

    //   if (window.sessionStorage.getItem("token")) {
    //     this.$router.replace(window.location.pathname);
    //   } else {
    //     this.$router.replace("/login");
    //   }

    //   // this.$router.replace("/test");
    //   // this.$router.replace("/videocenter");
    //   // this.$router.replace('/indexedDB');
    //   // this.$router.replace("/home");
    // }
    this.$router.replace("/register");
  },
};
</script>

<style scoped></style>
